module.exports = __webpack_public_path__ + "img/download-3-3.b48e355e.png";